/* eslint-disable no-unused-vars */
import { Col, Row } from 'antd';
import React, {
  useEffect, useRef, useState,
} from 'react';
import GeneratedTestSuitListViewItem from './GeneratedTestSuitListViewItem';
import Loading from '../../../components/Loading';
import ClientSidePagination from '../../../components/Pagination/ClientSidePagination';

interface propType {
  testcases: any[]
  deleteTestCase: (testcaseId: string) => Promise<boolean>
  selectTestCase: Function
  changeTestCaseOrder: Function
  isLoading: boolean
  currentPage: number
  pageSize: number
  total: number
  onPaginationChange: (page: number, pageSize: number) => void
}

const GeneratedTestcaseModuleListView = (
  {
    testcases,
    deleteTestCase,
    selectTestCase,
    isLoading = true,
    changeTestCaseOrder,
    currentPage,
    pageSize,
    total,
    onPaginationChange,
  }: propType,
) => {
  const [orderedItems, setOrderedItems] = useState<any[]>([]);
  const dragItem = useRef<any>();
  const dragOverItem = useRef<any>();
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedItems = orderedItems.slice(startIndex, startIndex + pageSize);

  const dragStart = (position: any) => {
    dragItem.current = position;
  };

  const dragEnter = (position: any) => {
    dragOverItem.current = position;
  };

  const drop = () => {
    const copyListItems = [...orderedItems];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    changeTestCaseOrder(copyListItems);
    setOrderedItems(copyListItems);
  };

  useEffect(() => {
    if (testcases) {
      setOrderedItems(testcases);
    }
  }, [testcases]);

  return (
    <div className="fp_list" style={{ marginTop: '0px' }}>
      <Row justify="space-between" className="fp_list_title">
        <Col span={8}><p>Name</p></Col>
        <Col span={6}><p>Project/Module</p></Col>
        <Col span={3}><p>Result</p></Col>
        <Col span={4}><p> </p></Col>
      </Row>
      {isLoading ? <Loading plain size="large" /> : paginatedItems?.map((testcase, index: number) => (
        <div
          draggable
          key={JSON.stringify(testcase)}
          onDragStart={() => dragStart(startIndex + index)}
          onDragEnter={() => dragEnter(startIndex + index)}
          onDragEnd={drop}
        >
          <GeneratedTestSuitListViewItem
            testcase={testcase}
            deleteTestCase={deleteTestCase}
            selectTestCase={selectTestCase}
          />
        </div>
      ))}
      {!isLoading && (
        <ClientSidePagination
          currentPage={currentPage}
          total={total}
          pageSize={pageSize}
          onPaginationChange={onPaginationChange}
        />
      )}
    </div>
  );
};

export default GeneratedTestcaseModuleListView;
